export default {
  default: () => import("/opt/buildhome/repo/layouts/default.vue"),
  planning: () => import("/opt/buildhome/repo/layouts/planning.vue")
}